(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

jQuery(document).ready(function ($) {
  Modernizr.webp;
  /*Modernizr.on( 'webp', function ( result ){
    if (result) {
      console.log( 'webp' );
    } else {
      console.log( 'no-webp' );
    }
  } );*/

  /* Add link to coupons */
  $(".coupon-link").on("click", function (e) {
    if (e.target.nodeName == 'A') {
      e.stopPropogation();
    }
    var theid = $(this).attr("id");
    var thelink = "";
    var thetarget;
    if ($("#" + theid).data("coupon-url") !== undefined) {
      thelink = $("#" + theid).data("coupon-url");
      thetarget = $("#" + theid).data("coupon-location");
      switch (thetarget) {
        case 'blank':
          {
            window.open(thelink, '_blank');
            break;
          }
        case 'self':
          {
            window.location.href = thelink;
            break;
          }
        default:
          {
            window.open(thelink, '_blank');
            break;
          }
      }
    }
  });
});

},{}],2:[function(require,module,exports){
"use strict";

require("./base.js");
/*import './vendor/modernizr.js';*/

/*
* Copyright (c) 2020 Matthew Swetnam
*/
jQuery(document).ready(function ($) {
  console.log("Canadensis");
});

},{"./base.js":1}]},{},[2]);
